export default __webpack_public_path__ + "static/media/title.e4502a23.svg";